/**
 * Firebase 읽기 횟수 추적 서비스
 */
class FirebaseReadCounter {
  private readCount: number = 0;
  private isEnabled: boolean = false;

  /**
   * 읽기 횟수 추적 활성화/비활성화
   */
  setEnabled(enabled: boolean): void {
    this.isEnabled = enabled;
    if (enabled) {
      this.reset();
    }
  }

  /**
   * 읽기 횟수 증가
   */
  increment(count: number = 1): void {
    if (this.isEnabled) {
      this.readCount += count;
    }
  }

  /**
   * 현재 읽기 횟수 조회
   */
  getCount(): number {
    return this.readCount;
  }

  /**
   * 읽기 횟수 초기화
   */
  reset(): void {
    this.readCount = 0;
  }

  /**
   * 읽기 횟수 로그 출력
   */
  logReadCount(context: string = ''): void {
    if (this.isEnabled) {
      console.log(`📊 Firebase 읽기 횟수${context ? ` (${context})` : ''}: ${this.readCount}회`);
    }
  }

  /**
   * 읽기 횟수 상세 분석
   */
  logDetailedAnalysis(context: string = ''): void {
    if (this.isEnabled) {
      console.log(`📊 Firebase 읽기 횟수 상세 분석${context ? ` (${context})` : ''}:`);
      console.log(`   - 총 읽기 횟수: ${this.readCount}회`);
      console.log(`   - 예상 비용: $${(this.readCount * 0.00006).toFixed(6)} (읽기 1회당 $0.00006)`);
    }
  }
}

export const firebaseReadCounter = new FirebaseReadCounter();

// 브라우저 전역에 함수 등록
if (typeof window !== 'undefined') {
  (window as any).firebaseReadCounter = {
    getCount: () => firebaseReadCounter.getCount(),
    reset: () => firebaseReadCounter.reset(),
    setEnabled: (enabled: boolean) => firebaseReadCounter.setEnabled(enabled),
    logReadCount: (context?: string) => firebaseReadCounter.logReadCount(context),
    logDetailedAnalysis: (context?: string) => firebaseReadCounter.logDetailedAnalysis(context)
  };
}
